// extracted by mini-css-extract-plugin
export var sliderRange = "_qw-2";
export var sliderRoot = "_qw-0";
export var sliderThumb = "_qw-3";
export var sliderTrack = "_qw-1";